var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        staticClass: "custom-page-header",
        attrs: {
          actions: _vm.pageActionConfig,
          "left-side-class": "col-xl-4",
          page: _vm.pageConfig,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-2 justify-content-end"
        }
      }),
      _vm.showCreateJournal
        ? _c("create-journal", {
            attrs: { "academic-years": _vm.catalog.academicYears },
            on: {
              "on-cancel": _vm.onCancelHandler,
              "on-continue": _vm.onContinueHandler
            }
          })
        : _vm._e(),
      _c("filter-manager", {
        ref: "attendanceFilterRef",
        staticClass: "mb-4 filter-manager-extended",
        attrs: { "display-advanced": false, filters: _vm.filterManagerConfig },
        on: { search: _vm.onSearchHandler },
        model: {
          value: _vm.filterModel,
          callback: function($$v) {
            _vm.filterModel = $$v
          },
          expression: "filterModel"
        }
      }),
      _c("custom-separator", {
        staticClass: "pt-3 my-4",
        attrs: { text: "Resultado de Jornal de Pagos" }
      }),
      _vm.result.data.length === 0 ? _c("custom-result-not-found") : _vm._e(),
      _c("search-result", {
        attrs: { result: _vm.result },
        on: { "on-page-change": _vm.onPageChangeHandler }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }